import { render, staticRenderFns } from "./MPopupConfirm.vue?vue&type=template&id=1a73318f&"
import script from "./MPopupConfirm.ts?vue&type=script&lang=ts&"
export * from "./MPopupConfirm.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports